export enum CreditCardTabTabsEnum {
    NewCreditCard = 1,
    SavedCreditCards = 2,
}